import * as Greenzine from "@coderehab/greenzine-react-deprecated";
import { MagazineModel } from "./magazine";

export interface MagazineProvider extends Greenzine.MagazineProvider {}

export default class AdminMagazineProvider extends Greenzine.DefaultMagazineProvider
  implements MagazineProvider {
  public model = MagazineModel;
}
